module.exports = __webpack_public_path__ + "img/I-agree.ed555971.svg";